module.exports = __webpack_public_path__ + "img/result-detail-output-inright01.c5af531e.svg";